'use client'

import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container, FormGroup, Input } from "reactstrap";
import estadoService from "services/EstadoService";
import municipioService from "services/MunicipioService";
import { erroInesperado } from "services/Utils";

export default function FormMunicipio() {
  const [data, setData] = useState({})
  const [estados, setEstados] = useState([])
  const [edit, setEdit] = useState(false)
  const params = useParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      municipioService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  useEffect(() => {
    setEstados(estadoService.get())
  }, [])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "nome", label: 'Nome', type: "text", required: true, colspan: 6 },
        { name: "uf", label: 'UF', type: "combo", options: estados, optionValue: 'sigla', optionLabel: 'nome', showDefault: true, required: true, colspan: 2 },
      ]
    ]
  }, [estados])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await municipioService.create(data)
      } else {
        await municipioService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/municipios')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Municípios" edit={edit} onChangeEdit={setEdit} showButton={!novo} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}